<script>
import LazyImage from "@/components/atoms/lazy-image";
import Card from "@/components/molecules/card";

import fideliteRemise from "@/assets/images/fidelite-remise.png";

export default {
  name: "FideliteMerchRemise",
  components: {
    LazyImage,
    Card
  },
  setup() {
    return {
      fideliteRemise
    }
  },
  props: {}
};
</script>
<template>
  <Card
    radius="md"
    border-color="grey-5"
    class="u-p-none"
  >
    <div class="c-fidelite-merch-remise">
      <div class="c-fidelite-merch-remise__text">
        <p class="u-font-24 u-font-700 u-font-secondary u-mb-md">
          Des remises sur les produits de marques cora
        </p>
        <p>
          Bénéficiez de 10% de remise<sup>(1)</sup> en €urocora le mercredi ou jeudi pour vos achats en magasin<sup>(2)</sup>, et une journée variable selon votre magasin pour les achats effectués sur cora.fr<sup>(3)</sup>. La remise s'applique sur les produits où figure l'une des marques suivantes :
        </p>
        <p class="u-font-10 u-mt-md">
          <sup>(1)</sup> Remise non cumulable avec les promotions en cours. Hors laits infantiles 1er âge, produits biocides, phytosanitaires, combustibles et traitement de l'eau.<br>
          <sup>(2)</sup> Magasins concernés par la remise de 10% le mercredi : Bruay-la-Buissière, Cambrai, Courrières, Dunkerque, Flers Villeneuve d'Ascq, Lens 2, Saint-Quentin et Wattignies. Les autres magasins proposent cette remise le jeudi.<br>
          <sup>(3)</sup> Voir conditions dans votre magasin cora.
        </p>
      </div>
      <LazyImage
        :src="fideliteRemise"
        alt=""
        width="475"
        height="274"
        class="c-fidelite-merch-remise__img"
      />
    </div>
  </Card>
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/fidelite-merch-remise.scss";
</style>
